// SPDX-License-Identifier: AGPL-3.0-or-later

import {reportSceneOpen, resendSceneOpen} from '@app/features/voice_scene/commands/RoomSceneCommands';
import {ConnectionState, type Room, RoomEvent} from 'livekit-client';
import {useEffect} from 'react';

// Open while the mounted 3D room has a connected call; the flat view, a scene failure (both unmount the room) and a
// disconnect close it. Only transitions reach the commands, which coalesce them.
export function useSceneViewReport({
	channelId,
	room,
	connectionId,
}: {
	channelId: string;
	room: Room | null;
	connectionId: string | null;
}): void {
	useEffect(() => {
		if (!room || !connectionId) return;
		const show = () => {
			if (room.state === ConnectionState.Connected) reportSceneOpen(room, channelId, connectionId, true);
		};
		// A (re)connect may bring a fresh participant without the mark; one opened while reconnecting has no report yet.
		const connected = () => {
			show();
			resendSceneOpen(room, channelId, connectionId);
		};
		show();
		room.on(RoomEvent.Connected, connected);
		room.on(RoomEvent.Reconnected, connected);
		return () => {
			room.off(RoomEvent.Connected, connected);
			room.off(RoomEvent.Reconnected, connected);
			reportSceneOpen(room, channelId, connectionId, false);
		};
	}, [channelId, room, connectionId]);
}
